import { Box, Typography, useTheme } from "@mui/material";
import { Icons } from "../../../models/assets-files";
import { ImageService } from "../../../services/image.service";
import Image from "../../common/Image";

interface FileTypeRowProps {
  fileType?: string;
}

const FileTypeRow = ({ fileType }: FileTypeRowProps) => {
  const theme = useTheme();
  return (
    <Box sx={{ ...theme.customStyles.flexStart, gap: "10px", height: "100%" }}>
      <Image
        src={ImageService.getLocalIconPath(
          Icons.Folders.FILE_TYPES,
          fileType || Icons.FileTypes.ELSE
        )}
      />
      <Typography sx={{ fontSize: "14px" }}>
        {(fileType || Icons.FileTypes.ELSE).capitalize()}
      </Typography>
    </Box>
  );
};

export default FileTypeRow;
